import { NotificationMessagesAccessors } from '@dtna/dvs-support-dcp-shared-state/lib/selectors/notificationMessages.selector';
import { IMessageBarMessage } from '@dtna/dvs-support-dcp-shared-state/lib/models/notificationMessages.model';
import { setRemoveMessageAction } from '@dtna/dvs-support-dcp-shared-state/lib/slices/notificationMessages.slice';
import { MessageBar } from '@dtna/dvs-core-dcp-ui-libraries';
import dompurify from 'dompurify';
import { useHostDispatch, useHostSelector } from '../store';

function Toasts() {
  const notificationMessages = useHostSelector(NotificationMessagesAccessors.getAppNotificationMessages);
  const dispatch = useHostDispatch();

  const handleRemoveMessageAction = () => {
    dispatch(setRemoveMessageAction);
  };

  return (
    <>
      {
        notificationMessages.map((message: IMessageBarMessage, index: number) => (
          <MessageBar key={message.id || index} isActive={!index} type={message.type} onRemoveMessageAction={handleRemoveMessageAction}>
            {typeof (message.message) === 'string' ? (
              <span dangerouslySetInnerHTML={{ __html: dompurify.sanitize(message.message) }} />
            ) : message.message}
          </MessageBar>
        ))
      }
    </>
  );
}

export default Toasts;
